module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/supercell-logo-7cbb660782910c9775ae9b7ae766d3cf.svg";